export const REACT_APP_API_BASE_URL =
process.env.NODE_ENV === 'development' ? (process.env.REACT_APP_API_BASE_URL as string) : ''
export const GOOGLE_CLOUD_API_KEY = process.env.REACT_APP_GOOGLE_CLOUD_API_KEY as string
